import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Notes } from 'components/common/Notes'
import { AddNoteModal } from 'components/common/modals/AddNoteModal'
import { toFormData } from 'components/Contact/serializers'
import * as ACT from 'components/Contact/actions'
import s from './ContactNotes.scss'
import { PUSH_NOTIFICATION } from 'actions/actionTypes'
import swal from 'sweetalert'

const ContactNotes = ({ contactId }) => {
  const [showAddNoteModal, setShowAddNoteModal] = useState(false)
  const [selectedNote, setSelectedNote] = useState(null)

  const dispatch = useDispatch()
  const notes = useSelector(state => state.contact.notes)

  const toggleAddNoteModal = selectedNote => {
    setShowAddNoteModal(!showAddNoteModal)
    setSelectedNote(selectedNote)
  }

  useEffect(() => {
    contactId &&
      dispatch({
        type: ACT.CONTACT_NOTES_FETCH_REQUESTED,
        payload: {
          id: contactId
        }
      })
  }, [contactId, dispatch])

  const addNote = (cb, contact, files, note, dateEntered, destroyEditor) => {
    dispatch({
      type: ACT.CONTACT_ADD_NOTE_REQUESTED,
      payload: {
        data: toFormData(contactId, files, note, dateEntered)
      }
    })
    destroyEditor?.()
    cb?.()
  }

  const updateNote = (noteId, cb, contact, files, note, dateEntered, destroyEditor) => {
    dispatch({
      type: ACT.CONTACT_UPDATE_NOTE_REQUESTED,
      payload: {
        data: toFormData(contactId, files, note, dateEntered),
        noteId
      }
    })
    destroyEditor?.()
    cb?.()
  }

  const deleteNote = async noteId => {
    const willRemove = await swal({
      title: 'Are you sure you want to delete this note?',
      text: 'This action can’t be undone',
      buttons: ['Cancel', 'Yes'],
      icon: 'warning'
    })
    if (willRemove) {
      try {
        dispatch({
          type: ACT.CONTACT_DELETE_NOTE_REQUESTED,
          payload: {
            noteId
          }
        })
      } catch (e) {
        dispatch({
          type: PUSH_NOTIFICATION,
          payload: {
            title: 'There was a problem deleting note',
            level: 'error'
          }
        })
      }
    }
  }

  return (
    <section className={s.notesContainer}>
      <Notes
        notes={notes}
        toggleAddNoteModal={toggleAddNoteModal}
        hideContact
        deleteNote={deleteNote}
      />
      <AddNoteModal
        toggleAddNoteModal={toggleAddNoteModal}
        showAddNoteModal={showAddNoteModal}
        selectedNote={selectedNote}
        addNote={addNote}
        updateNote={updateNote}
      />
    </section>
  )
}

export default ContactNotes
